module.exports = __webpack_public_path__ + "media/images/micinn-8c3515c8dd8cbae8aa5c42b3cb624a4a.png";